/** Wordmark: four process-colour dots (C, M, Y, K) and RDK. */
export function Logo({ compact = false, inverse = false }: { compact?: boolean; inverse?: boolean }) {
  return (
    <span className={`logo${inverse ? ' logo--inverse' : ''}`} aria-label="RDK">
      <svg viewBox="0 0 20 20" className="logo__mark" aria-hidden="true">
        <circle cx="5" cy="5" r="4" fill="#00A3E0" />
        <circle cx="15" cy="5" r="4" fill="#E6007E" />
        <circle cx="5" cy="15" r="4" fill="#FFD500" />
        <circle cx="15" cy="15" r="4" className="logo__k" />
      </svg>
      <span className="logo__word">RDK</span>
      {!compact && <span className="logo__tag">Digital Decoration. Made Personal.</span>}
    </span>
  );
}
